// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=OkResponseWrappingAreaMeasurementUnitList|schemaHash=e894cf2075a8ddc1033f6e8d0965c4b2212aa443

import { setDefinedValue } from '@myre/common-primitives';

import { parseAreaMeasurementUnitFromJSON, parseAreaMeasurementUnitToJSON } from './AreaMeasurementUnit';
import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseWrappingAreaMeasurementUnitListFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaFromJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseAreaMeasurementUnitFromJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseOkResponseWrappingAreaMeasurementUnitListToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaToJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseAreaMeasurementUnitToJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}
